import { configureStore } from "@reduxjs/toolkit";
import authReducer from './auth'
import newsReducer from './news'
import headerReducer from './Header'
import filterOptionsReducer from './FiltersOptions'
import { alertFilterReducer, reportFilterReducer, alertPlatformReducer, userFilterReducer, memberAnalyticsFilterReducer } from "./filter.slice";

const store = configureStore({
    reducer: {
        auth: authReducer,
        news: newsReducer,
        headerMenu: headerReducer,
        alertFilter: alertFilterReducer,
        reportFilter: reportFilterReducer,
        alertPlatformFilter: alertPlatformReducer,
        userFilter: userFilterReducer,
        memberAnalyticsFilter: memberAnalyticsFilterReducer,
        filterOptions: filterOptionsReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
          serializableCheck: false,
        }),
})

export default store;